import APIClient from '@/shared/http/clients/api'

const resourceName = 'REProposta'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllWeb = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/solicitacoes`, data, config)
const GetAllTowers = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search/towers`, data, config)
const GetAllApartments = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search/apartments`, data, config)
const GetAllRealEstates = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search/realestate`, data, config)
const GetAllEnterprises = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllEnterprises`, data, config)
const GetAllBroker = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/search/broker`, data, config)
const GetFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro/proposta?limit=${limit}&index=${index}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const AprovarSolicitacao = (id, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/aprovar/${id}`, data, config)
const ReprovarSolicitacao = (id, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/reprovar/${id}`, data, config)
const PendenciaDeSolicitacao = (id, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/pendente/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, config)
const GetAllPaging = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/solicitacoes?limit=${limit}&index=${index}`, data, config)
const GetSolicitacoesReprovadas = (id, data, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/reprovados/${id}`, data, config)
const ResolverPendenciasAprovacao = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/resolver/${id}`, data, config)
const GetCorretorByNameProposta = (nome, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getCorretorByNameProposta/${nome}`, data, config)
const GetClienteByNameProposta = (nome, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getClienteByNameProposta/${nome}`, data, config)
const GetAllEnterprisesByApprovedRequest = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllEnterprisesByApprovedRequest`, data, config)

const RequestsRepository = {
  GetAllWeb,
  GetFiltro,
  Update,
  AprovarSolicitacao,
  ReprovarSolicitacao,
  PendenciaDeSolicitacao,
  GetAllTowers,
  GetAllRealEstates,
  GetAllBroker,
  GetAllApartments,
  Delete,
  GetAllPaging,
  GetSolicitacoesReprovadas,
  ResolverPendenciasAprovacao,
  GetCorretorByNameProposta,
  GetClienteByNameProposta,
  GetAllEnterprises,
  GetAllEnterprisesByApprovedRequest
}

export default RequestsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/requestRepository.js